



































import { Component, Prop, PropSync, Vue } from 'vue-property-decorator'

@Component
export default class CallDetailInfoDialog extends Vue {

  @PropSync('show') active!: boolean;
  @Prop() messageContent!: any;

}
